import { useMemo } from "react";
import { Button, Heading, Popover, Portal, Stack, Checkbox, Box, Text, SimpleGrid } from "@chakra-ui/react";
import { LuLayoutTemplate } from "react-icons/lu";
import { Tooltip } from "../../ui/tooltip";
import { useAppStore } from "../../../context/store";

export default function CustomizeTools() {
  const toolsEnabled = useAppStore((s) => s.toolsEnabled);
  const setToolEnabled = useAppStore((s) => s.setToolEnabled);

  const toolGroups = useMemo(
    () => [
      {
        title: "Measurement",
        tools: [
          { id: "measureDistance", label: "Measure Distance" },
          { id: "lineIntersectMeasure", label: "Line Intersect" },
          { id: "measureArea", label: "Measure Area" },
        ],
      },
        {
        title: "Search / Display",
        tools: [
          { id: "quickSearch", label: "Quick Search" },
          { id: "showPoints", label: "Show Points" },
        ],
      },
      {
        title: "Other",
        tools: [
          { id: "turningArcTool", label: "Turning Arc Tool" },
          { id: "arc", label: "Arc" },
          { id: "overlayText", label: "Overlay Text" },
          { id: "pointCloud", label: "Point Cloud" },
          { id: "validationMenu", label: "Validation" },
          { id: "association", label: "Association" },
          { id: "movingTool", label: "Move Tool" },
          { id: "autoSketcher", label: "Auto Sketcher" },
          { id: "globalTools", label: "Global Tools" },
        ],
      },
    

      {
        title: "Lanelet / Road",
        tools: [
          { id: "lanelet", label: "Lanelet" },
          { id: "laneConnector", label: "Lane Connector" },
          { id: "LaneletCheckByIds", label: "Lanelet Check By Ids" },
          { id: "AutomaticConnectionCheck", label: "Lanelet Automatic Connection Check" },
          { id: "roadMarking", label: "Road Marking" },
          { id: "lanemarkerTool", label: "Lane Marker Editor" },
          { id: "generateRoute", label: "Generate Route" },
          { id: "driveway", label: "Driveway" },
        ],
      },
      {
        title: "Objects",
        tools: [
          { id: "trafficLight", label: "Traffic Light" },
          { id: "trafficSign", label: "Traffic Sign" },
        ],
      },
    ],
    [],
  );

  return (
    <Popover.Root positioning={{ placement: "left-start" }}>
      <Popover.Trigger asChild>
        <Button userSelect="none" p={0} bg="gray.400">
          <Tooltip content="Customize Tools">
            <LuLayoutTemplate color="MenuText" />
          </Tooltip>
        </Button>
      </Popover.Trigger>

      <Portal>
        <Popover.Positioner>
          <Popover.Content w="fit-content" maxW="none">
            <Popover.Arrow />
            <Popover.Body p={3}>
              <Heading fontSize="lg" mb={3}>
                Customize Tools
              </Heading>

              <SimpleGrid columns={2} gap={2}>
                {toolGroups.map((group) => (
                  <Box key={group.title}>
                    <Text fontWeight="bold" fontSize="sm" mb={2}>
                      {group.title}
                    </Text>

                    <Stack gap={2} pl={1}>
                      {group.tools.map((t) => (
                        <Checkbox.Root
                          key={t.id}
                          checked={!!toolsEnabled?.[t.id]}
                          onCheckedChange={(details) => setToolEnabled(t.id, details.checked === true)}
                          display="flex"
                          alignItems="center"
                          gap={2}
                          cursor="pointer"
                        >
                          <Checkbox.HiddenInput />
                          <Checkbox.Control />
                          <Checkbox.Label whiteSpace="nowrap">{t.label}</Checkbox.Label>
                        </Checkbox.Root>
                      ))}
                    </Stack>
                  </Box>
                ))}
              </SimpleGrid>
            </Popover.Body>
          </Popover.Content>
        </Popover.Positioner>
      </Portal>
    </Popover.Root>
  );
}
